import React from 'react';
import styled from 'styled-components';
import DefaultText from './DefaultText';
import {minmax} from 'utils/minmax';
import {colors} from '../../styles/colors';

/**
 * 컨테이너 헤더 컴포넌트의 Props 인터페이스
 * @property {string} [mainTitle] - 메인 제목
 * @property {React.CSSProperties} [mainTitleStyle] - 메인 제목 스타일
 * @property {string} [subTitle] - 서브 제목
 * @property {React.CSSProperties} [subTitleStyle] - 서브 제목 스타일
 * @property {React.ReactNode} [children] - 자식 요소
 * @property {React.CSSProperties} [containerStyle] - 컨테이너 스타일
 * @property {() => void} [onClickContainer] - 컨테이너 클릭 이벤트 핸들러
 */
interface Props {
  mainTitle?: string;
  mainTitleStyle?: React.CSSProperties;
  subTitle?: string;
  subTitleStyle?: React.CSSProperties;
  children?: React.ReactNode;
  containerStyle?: React.CSSProperties;
  onClickContainer?: () => void;
}

/**
 * 컨테이너 헤더 컴포넌트
 * 컨테이너 상단에 표시되는 헤더 컴포넌트입니다.
 * @param {Props} props - 컨테이너 헤더 컴포넌트의 props
 * @returns {JSX.Element} 컨테이너 헤더 컴포넌트
 */
const ContainerHeader = ({
  mainTitle,
  subTitle,
  mainTitleStyle,
  subTitleStyle,
  children,
  containerStyle,
  onClickContainer,
}: Props) => {
  return (
    <Container style={containerStyle} onClick={onClickContainer}>
      {mainTitle && (
        <div
          style={{
            // height: minmax(69),
            display: 'flex',
            alignItems: 'center',
            marginRight: minmax(10),
          }}>
          <DefaultText text={mainTitle ?? ''} textStyle={mainTitleStyle} />
        </div>
      )}
      {subTitle ? (
        <>
          <DefaultText
            text=">"
            textStyle={{
              fontWeight: 500,
              fontSize: minmax(26),
              ...subTitleStyle,
            }}
          />

          <DefaultText
            text={subTitle ?? ''}
            textStyle={{
              fontWeight: 500,
              fontSize: minmax(26),

              ...subTitleStyle,
            }}
          />
        </>
      ) : null}
      {children}
    </Container>
  );
};

export default ContainerHeader;

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: ${minmax(14)} 0 ${minmax(14)} ${minmax(24)};
  flex-direction: row;
  background-color: ${colors.lighterGray};
  margin-bottom: ${minmax(20)};
  > p {
    padding-right: max(6px, min(1.2vw, 10px));
  }
`;
